import axios from 'utils/axios';

export const createDailyConclusionStrategy = (params?: any) => {
  return axios.post(`/api/v1/dailyconclusionstrategies`, params);
};
